exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul > li[data-v-7a7aecfa]{\n  list-style: disc;\n  margin-left: 1.0em;\n  padding: .5em .5em .5em 0;\n}\n", ""]);

// exports
